import keyMirror from 'keymirror';

export default keyMirror({
  GET_ACCOUNT_POOLS: null,
  GET_ACCOUNT_POOLS_SUCCESS: null,
  GET_ACCOUNT_POOLS_FAILURE: null,
  SET_ACCOUNT_POOL_ID: null,
  CREATE_ACCOUNT_POOL: null,
  CREATE_ACCOUNT_POOL_SUCCESS: null,
  CREATE_ACCOUNT_POOL_FAILURE: null,
  GET_ACCOUNT_LIST: null,
  GET_ACCOUNT_LIST_SUCCESS: null,
  GET_ACCOUNT_LIST_FAILURE: null,
  RESET_POOL: null,
  UPDATE_POOL: null,
  UPDATE_POOL_SUCCESS: null,
  UPDATE_POOL_FAILURE: null,
  POOL_NAME_KEY: 'poolName',
  POPULAR_CURRENCY_KEY: 'popularNotionalCurrency',
  CURRENCY_SELECT_KEY: 'notionalCurrency',
  DELETE_ACCOUNT_POOL: null,
  GET_SPECIFIC_POOL_DETAIL: null,
  GET_SPECIFIC_POOL_DETAIL_SUCCESS: null,
  GET_SPECIFIC_POOL_DETAIL_FAILURE: null,
  SET_EDIT_MODE: null,
  EXPORT_TRANSACTIONS: null,
  EXPORT_TRANSACTIONS_SUCCESS: null,
  EXPORT_TRANSACTIONS_FAILURE: null,
  RESET_ACCOUNT_DETAIL_FLAG: null,
  30: 'poolNameMaxLength',
  101: 'totalMaxPoolsAllowed',
});
